import router from '@/router'
import { store } from '@/store/store'
import Vue from 'vue'

const handleResponseStatus = async (status, reason) => {
  switch (status) {
    case 400:
      await forceLogout(reason)
      break
    case 200:
      break
    default:
      await Vue.swal.fire({ type: 'error', text: reason })
      break
  }
  return
}

export const handleResponse = async (response) => {
  if (response) {
    const reason =
      response.data && (response.data.reason || response.data.message)
        ? response.data.reason || response.data.message
        : undefined
    if (reason) {
      console.error(reason)
    }
    if (response.data && response.data.responsecode) {
      await handleResponseStatus(response.data.responsecode, reason)
    }
  }
  return
}

export const handleApiError = async (error) => {
  if (error) console.error(error)

  if (error.response) {
    const reason =
      error.response.data && (error.response.data.reason || error.response.data.message)
        ? error.response.data.reason || error.response.data.message
        : error.toString() || undefined

    await handleResponseStatus(error.response.status, reason)
  }
  return
}

export const forceLogout = async (reason = 'Session expire. Please login again.') => {
  await store.dispatch('logout', {
    code: 400,
    message: reason
  })

  if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
    router.push({
      path: `/${store.getters.currentLang}/nigol`,
      query: {
        ...router.query,
        redirect: router.currentRoute.fullPath
      }
    })
  }

  return reason
}



// WEBPACK FOOTER //
// ./src/api/util.js